<template>
    <div class="aup-error-label d-inline-block h-100">
        <p>error:call:4</p>
    </div>
</template>
<script>
	export default {
        name: "BaseErrorLabel",
        props: {
            error: {
                type: String,
                default: ""
            }
        }
    };
</script>

<style lang="scss">
    @import "../../assets/scss/all";
    .aup-error-label {
        color: $sony-red;
    }
</style>
